import React from 'react';

const WhatsappWidget: React.FC = () => {
  const [hidden, setHidden] = React.useState(false);

  React.useEffect(() => {
    const checkModal = () => {
      setHidden(document.body.classList.contains('demo-modal-open'));
    };

    checkModal();

    const observer = new MutationObserver(checkModal);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    return () => observer.disconnect();
  }, []);

  if (hidden) return null;

  return (
    <>
      <div className="fixed bottom-[85px] right-[20px] z-[9999] flex items-center group select-none">
        {/* Text bubble displayed on hover */}
        <a
          href="https://wa.me/917387186843"
          target="_blank"
          rel="noopener noreferrer"
          className="opacity-0 translate-x-4 pointer-events-none group-hover:opacity-100 group-hover:translate-x-0 group-hover:pointer-events-auto transition-all duration-300 bg-white text-[#25D366] font-bold px-4 py-2 rounded-full shadow-[0_4px_12px_rgba(0,0,0,0.1)] border border-gray-100 mr-2 whitespace-nowrap text-sm"
        >
          Chat on WhatsApp
        </a>

        {/* WhatsApp Floating Button */}
        <a
          href="https://wa.me/917387186843"
          target="_blank"
          rel="noopener noreferrer"
          className="w-[55px] h-[55px] bg-[#25D366] hover:bg-[#20ba5a] text-white rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-105 active:scale-95 animate-pulse-ring-whatsapp"
          title="Chat on WhatsApp"
        >
          <svg viewBox="0 0 24 24" className="w-7 h-7 fill-current">
            <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946C.06 5.348 5.397.01 12.008.01c3.202.001 6.212 1.246 8.477 3.514 2.266 2.268 3.507 5.28 3.505 8.484-.004 6.657-5.34 11.997-11.953 11.997-2.005-.001-3.973-.502-5.724-1.455L0 24zm6.59-4.846c1.6.95 3.188 1.449 4.825 1.451 5.436 0 9.86-4.37 9.864-9.799.002-2.63-1.023-5.101-2.885-6.967C16.488 1.973 14.02 1.488 12.006 1.488c-5.437 0-9.861 4.37-9.866 9.8-.001 1.77.464 3.5 1.346 5.03l-.988 3.606 3.693-.97c1.53.873 3.2 1.2 4.857 1.2zm8.683-6.55c-.24-.12-1.417-.7-1.637-.78-.22-.08-.38-.12-.54.12-.16.24-.62.78-.76.94-.14.16-.28.18-.52.06-.24-.12-.992-.367-1.89-1.168-.7-.624-1.173-1.395-1.31-1.635-.14-.24-.015-.37.106-.49.11-.11.24-.28.36-.42.12-.14.16-.24.24-.4.08-.16.04-.3-.02-.42-.06-.12-.54-1.3-.74-1.78-.195-.47-.393-.406-.54-.414-.14-.007-.3-.008-.46-.008-.16 0-.42.06-.64.3-.22.24-.84.82-.84 2s.86 2.32.98 2.48c.12.16 1.69 2.581 4.1 3.62.573.248 1.02.395 1.37.505.577.183 1.1.157 1.51.096.458-.069 1.416-.58 1.616-1.14.2-.56.2-1.04.14-1.14-.06-.1-.22-.16-.46-.28z" />
          </svg>
        </a>
      </div>

      <style>{`
        .animate-pulse-ring-whatsapp {
          animation: pulse-ring-whatsapp 2s infinite cubic-bezier(0.25, 0.8, 0.25, 1);
        }
        @keyframes pulse-ring-whatsapp {
          0% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.5); }
          80%, 100% { box-shadow: 0 0 0 15px rgba(37, 211, 102, 0); }
        }
      `}</style>
    </>
  );
};

export default WhatsappWidget;
